// Cliente de la API. La web usa la cookie de sesión (mismo dominio); no guarda tokens en el navegador.

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message);
  }
}

async function handle<T>(res: Response): Promise<T> {
  if (res.ok) return (await res.json()) as T;
  let message = 'Algo salió mal. Probá de nuevo.';
  try {
    message = ((await res.json()) as { message?: string }).message ?? message;
  } catch {
    // respuesta sin JSON
  }
  throw new ApiError(res.status, message);
}

export async function api<T>(path: string, init: RequestInit & { json?: unknown } = {}): Promise<T> {
  const { json, ...rest } = init;
  const res = await fetch(`/api${path}`, {
    credentials: 'same-origin',
    ...rest,
    headers: { ...(json !== undefined ? { 'content-type': 'application/json' } : {}), ...(rest.headers ?? {}) },
    body: json !== undefined ? JSON.stringify(json) : rest.body,
  });
  return handle<T>(res);
}

export const post = <T>(path: string, json?: unknown) => api<T>(path, { method: 'POST', json: json ?? {} });
export const patch = <T>(path: string, json: unknown) => api<T>(path, { method: 'PATCH', json });
export const del = <T>(path: string) => api<T>(path, { method: 'DELETE' });

export async function upload<T>(path: string, form: FormData): Promise<T> {
  return handle<T>(await fetch(`/api${path}`, { method: 'POST', body: form, credentials: 'same-origin' }));
}

export const googleUrl = (role: 'candidate' | 'company' | 'admin', redirect: string) =>
  `/api/auth/google/start?role=${role}&redirect=${encodeURIComponent(redirect)}`;
